export interface BrandData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  street: string;
  street2: string;
  city: string;
  region: string;
  postalCode: string;
  brandName: string;
  registrationStatus?: string;
}

export enum TwilioStepStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  Failed = 'Failed',
  ToBeExecuted = 'ToBeExecuted',
}

export interface TwilioStep {
  step: string;
  status: TwilioStepStatus;
}

export interface TwilioStepGroup {
  group: string;
  steps: TwilioStep[];
}

export interface TwilioRegStatus {
  nextStepCheckTimer: number;
  inProgress: boolean;
  started: boolean;
  completed: boolean;
  failed: boolean;
  lastStepErr: string;
  stepGroups: TwilioStepGroup[];
  brandCreated: boolean;
  brandTwilioApproved: boolean;
  brandOtpApproved: boolean;
  campaignVerified: boolean;
  phoneNumber: string;
  phoneNumberId: string;
}

export interface TwilioUserRegStatus {
  completed: boolean;
}

export interface TwilioConfig {
  messageLimit: number;
  messageLimitCurrent: number;
  additionalMessageLimit: number;
}

export interface TwilioPhoneNumber {
  sid: string;
  phoneNumber: string;
  region?: string;
  locality?: string;
}

export interface PostsConfig {
  postsLimitCurrent: number;
  additionalPostsLimit: number;
}
